import { ItemList } from 'orm'

class KpiResultList extends ItemList {
    getEntityKey() {
        return "admin/kpi_result"
    }
}

export const adminKpiResultList = new KpiResultList("admin_kpi_result__default")
